import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20education%20background%20with%20soft%20gradient%20from%20warm%20beige%20to%20cream%2C%20subtle%20abstract%20shapes%2C%20Asian%20design%20inspired%20patterns%2C%20clean%20aesthetic%2C%20scholarly%20yet%20modern%20atmosphere%2C%20no%20text&width=1920&height=800&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          开启你的日韩学习之旅
        </h2>
        <p className="text-base text-background-50/80 max-w-xl mx-auto mb-8">
          无论你是零基础入门还是职场进阶提升，
          日韩一区二区成人教育平台都能为你提供最匹配的课程方案
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/language"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即开始学习
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold text-base border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}